module.exports = __webpack_public_path__ + "img/paycard.c90731cd.gif";